module.exports = require("./jgo");